import React from 'react';
import ExperienceTimeline from '../components/experience/ExperienceTimeline';
import ExperimentGrid from '../components/experiments/ExperimentGrid';
import SiteFooter from '../components/footer/SiteFooter';
import PerceptionLab from '../components/lab/PerceptionLab';
import SiteHeader from '../components/navigation/SiteHeader';
import SkipLink from '../components/ui/SkipLink';
import SelectedWork from '../components/work/SelectedWork';
import WritingSection from '../components/writing/WritingSection';
import about from '../data/about';
import resume from '../data/resume';
import styles from './HomePage.module.css';

function HomePage() {
  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main className={styles.main} id="main-content">
        <section
          id="about"
          className={`${styles.section} ${styles.intro}`}
          aria-labelledby="about-title"
        >
          <p className={styles.label}>Today</p>
          <h1 id="about-title">AI engineer building agents in San Francisco.</h1>
          <div className={styles.introduction}>
            <p>
              Hi! I&rsquo;m Sergio, a software and AI engineer based in San Francisco. Welcome to my
              corner of the Internet, where I showcase my work, experiments, unfinished or
              imperfect projects, and the many other things I&rsquo;m exploring.
            </p>
            <p>{about.bio[0]}</p>
            <p>{about.bio[1]}</p>
            <p>{about.bio[2]}</p>
            <p>
              When not building, you can find me on the archery range, playing guitar, or lifting
              — usually while thinking about the next system I want to take apart.
            </p>
          </div>
        </section>

        <SelectedWork />
        <ExperimentGrid />
        <WritingSection />
        <PerceptionLab />
        <ExperienceTimeline />

        <section
          id="contact"
          className={`${styles.section} ${styles.contact}`}
          aria-labelledby="contact-title"
        >
          <h2 id="contact-title">Contact</h2>
          <div className={styles.contactLines}>
            <p>
              Want to get in touch or just say hi? Write to{' '}
              <a href={`mailto:${about.contact.email}`}>{about.contact.email}</a>.
            </p>
            <p>
              Find my work on{' '}
              <a href={about.contact.github} target="_blank" rel="noreferrer">
                GitHub
              </a>{' '}
              or{' '}
              <a href={about.contact.linkedin} target="_blank" rel="noreferrer">
                LinkedIn
              </a>
              , download my <a href={resume.pdfPath}>résumé</a>, or meet me for coffee if
              you&rsquo;re in San Francisco.
            </p>
          </div>
        </section>
      </main>

      <SiteFooter />
    </>
  );
}

export default HomePage;
